import React from 'react';
import NotesComponent from './NotesComponent';

/**
 * Entry point for the Notes feature.
 * Directly renders the NotesComponent, which consumes the Redux store.
 * to use Redux hooks (useDispatch/useSelector) instead of useNotesContext().
 * If NoteEditor still uses useNotesContext(), it will continue to crash.
 */
const Notes = (props) => {
    return (
        <NotesComponent {...props} />
    );
};

export default Notes;